module.exports = __webpack_public_path__ + "img/candy-crush-saga.3ab051d1.png";